module.exports = __webpack_public_path__ + "img/5.cb9de3cf.svg";